import React from "react";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { formatDisplayDate } from "../../../utils/helperFunctions";
import StatusChip from "../../common/StatusChip";
import { Button } from "../../ui/button";
import { IdPair, NoStage } from "./DeliveryCells";

/** A request with nothing delivered yet. */
const PendingDeliveryRow = ({
  row,
  canCreateDelivery,
  onOpenRequest,
  onDeliverRequest,
}) => (
  <TableRow
    hover
    onClick={() => onOpenRequest(row.ad_request_id)}
    sx={{ cursor: "pointer" }}
  >
    <TableCell sx={{ color: "text.secondary" }}>
      <Tooltip title="Not delivered yet — no delivery ID" arrow>
        <span>
          <IdPair adId={row.ad_id} deliveryId={null} />
        </span>
      </Tooltip>
    </TableCell>
    <TableCell
      sx={{ color: "text.secondary", maxWidth: 220, wordBreak: "break-all" }}
    >
      {row.adset_name || row.ad_name || row.topic || "—"}
      {row.hooks_count ? (
        <span className="block text-[11px] text-gray-500">
          {row.hooks_count} hook{row.hooks_count > 1 ? "s" : ""} requested
        </span>
      ) : null}
    </TableCell>
    <TableCell sx={{ color: "text.secondary" }}>—</TableCell>
    <TableCell>
      <StatusChip subtle status="delivery_pending" size="small" />
    </TableCell>
    <TableCell>
      <NoStage />
    </TableCell>
    <TableCell>
      <NoStage />
    </TableCell>
    <TableCell align="right">
      {canCreateDelivery ? (
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="h-8"
          onClick={(e) => {
            e.stopPropagation();
            onDeliverRequest?.(row.ad_request_id);
          }}
        >
          Deliver
        </Button>
      ) : (
        <span className="text-xs text-muted-foreground">—</span>
      )}
    </TableCell>
    <TableCell sx={{ color: "text.secondary" }}>
      {formatDisplayDate(row.created_on) ?? "—"}
    </TableCell>
  </TableRow>
);

export default PendingDeliveryRow;
